var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"h-app"}},[(_vm.showSubApp)?_c('m-layout'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/conf/home/App.vue